import produce from 'immer';

import {globalAssigneesToRawAssignees} from './assignees-to-raw';

import type {AssigneesByType, AssigneeType, SetAssignmentsType} from './types';
import type {ActionMeta} from 'app/components/general/SweetReactSelect';

export function applyChangeToAssignment(
  meta: ActionMeta<AssigneeType>,
  ctname: 'user' | 'team' | 'role',
  attr: 'step_id' | 'lane',
  id: string,
  setAssignments: SetAssignmentsType
) {
  setAssignments((assignments) =>
    produce(assignments, (draft) => {
      // list of urls of globally assignees, so we can quickly find them
      const globalAssignments = globalAssigneesToRawAssignees(
        assignments.global
      );

      if (meta.action == 'select-option') {
        // Added to a step.
        const assignee = meta.option;
        const assignment = {[ctname]: assignee, [attr]: id};

        draft.granular.push(assignment as any);
        if (globalAssignments[`${ctname}_ids`].indexOf(assignee.url) == -1) {
          // also add it to the global assignment as well
          // if it's not there yet
          draft.global[`${ctname}s`].push(assignee as any);
        }
      } else if (meta.action == 'remove-value') {
        // removing a single item.
        const assignee = meta.removedValue;
        draft.granular = draft.granular.filter(
          (assignment) =>
            assignment[ctname]?.url != assignee.url || assignment[attr] != id
        );
      } else if (meta.action == 'clear') {
        // removing all items for this content type..
        draft.granular = draft.granular.filter(
          (assignment) =>
            !(assignment[attr] === id && assignment[ctname] != null)
        );
      }
    })
  );
}

export function hasAnyAssignee(assignees?: AssigneesByType): boolean {
  return Boolean(
    assignees?.users?.length ||
      assignees?.teams?.length ||
      assignees?.roles?.length
  );
}
